import * as React from "react";
import { useSelector } from "react-redux";
import { sendChatMessage } from "../../../../helpers/mqttService";
import TextMessage from "../TextMessage";
import HTMLReactParser from "html-react-parser";
import { md, TextWrapper, isClean } from "..";
import _ from "lodash";
import { decodeEntities, htmlToReactEl } from "./utils";

type Props = {
  assignChatId: string
  msg: {
    title: string;
    text?: string
    style: { orientation: "V" | "H" };
    choices: { id: number; label: string }[];
  };
  fromId: string
  fromName: string;
  mId: string;
  isPrivate: boolean
  logs: any[]
};

export function SimpleChoice(props: Props) {
  const activeRootTab = useSelector((state: any) => state.ui.activeRootTab)
  const { assignChatId, msg, isPrivate, logs, fromId } = props
  const liOptions = React.useRef<HTMLLIElement[]>([]);

  const isUser = fromId.includes("u/");
  const simpleChoiceTitle = msg.text ? msg.text : msg.title
  const lastMsg = logs[logs.length - 1]

  const layoutStyle: React.CSSProperties = {
    display: "flex",
    justifyContent: "flex-end",
  };

  const shouldShowActions =
    lastMsg && lastMsg.msgType === "simpleChoice" && (props.mId === lastMsg.mId) && activeRootTab === 'live';

  const optionListContainerStyle: React.CSSProperties = {
    listStyle: "none",
    flexWrap: "wrap",
    display: "flex",
    justifyContent: "space-between",
    paddingLeft: 0,
    // maxWidth: "250px",
    alignContent: "center",
  };
  const containerStyle: React.CSSProperties = {
    marginBottom: false ? "25px" : "0px",
    border: "1px solid #f0f0f0",
    color: "#6b6b6b",
    backgroundColor: "#ffffff",
    borderRadius: "4px 14px 0px 4px",
  };
  const outline: React.CSSProperties = {
    padding: "16px",
    borderRadius: "4px 14px 0px 4px"
  };
  const titleStyle: React.CSSProperties = {
    fontSize: "16px",
    fontWeight: shouldShowActions ? 600 : 600,
    marginBottom: "8px",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    color: "#6b6b6b",
  };

  const optionListStyle: React.CSSProperties = {
    // minWidth: "45%",
    width: msg.style.orientation === "V" ? "100%" : "auto",
    margin: "5px",
    padding: "8px 20px",
    cursor: "pointer",
    flexGrow: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "15px",
    fontWeight: 500,
    height: "auto",
    textAlign: "center",
    fontFamily: "inherit",
    wordWrap: "break-word",
    color: "#000000",
    borderRadius: "15px",
    boxShadow: "0px 2px 5px 0px rgb(226 226 226)",
    border: "1px solid #e8e9f1",
    background: "#ffffff"
    // minWidth: 104
  };
  const optionStyle: React.CSSProperties = {
    wordBreak: "break-word",
    fontFamily: "inherit",
  };

  const optionHover = (liOption: HTMLLIElement, isFlag: boolean) => {
    if (shouldShowActions && liOption) {
      liOption.style.background = isFlag
        ? "#edecec"
        : "#ffffff";
      liOption.style.color = isFlag
        ? "#2d2d2d"
        : "#000000";
    }
  };

  const handleOptionSelect = (data: any) => {
    if (activeRootTab === "live") {
      sendChatMessage({
        msgType: "simpleChoiceResponse",
        msg: data,
        chatId: assignChatId,
        isPrivate,
      });
    }
  };

  if (!shouldShowActions) {
    return (
      <TextWrapper>
        <TextMessage
          isUser={!isUser}
          fontSize="16px"
          color="#212332"
          backgroundColor={isUser ? "#e8e9f1" : "#FBEBE3"}
          message={HTMLReactParser(
            isClean(md.render(_.unescape(simpleChoiceTitle.trim())))
              .replace(/[\r|\n|\r\n]$/, "")
              .replace(/\n/g, "<br />")
          )}
        />
      </TextWrapper>
    )
  }

  return (
    <div style={layoutStyle}>
      <div style={containerStyle}>
        <div style={outline}>
          <div style={titleStyle}>{htmlToReactEl(msg.title)}</div>
          <ul style={optionListContainerStyle}>
            {msg.choices &&
              msg.choices.map((choice, index) => {
                return (
                  <li
                    ref={(el) => {
                      if (liOptions.current && el) {
                        liOptions.current[index] = el;
                      }
                    }}
                    onMouseEnter={() => optionHover(liOptions.current[index], true)}
                    onMouseLeave={() => optionHover(liOptions.current[index], false)}
                    style={optionListStyle}
                    title={decodeEntities(choice.label)}
                    key={choice.id || index}
                    onClick={() => handleOptionSelect(choice)}
                  >
                    <span style={optionStyle}>{htmlToReactEl(choice.label)}</span>
                  </li>
                );
              })}
          </ul>
        </div>
      </div>
    </div>
  );
}
